// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Copyright 2024 European Commission

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

* {
  box-sizing: border-box;
}

*:before,
*:after {
  box-sizing: border-box;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

body {
  margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.container {
  width: 100%;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px; 
}

@media screen and (min-width: 1200px) {
  .container {
    padding-left: 30px;
    padding-right: 30px;
  }
}

/**
  Link
**/

a {
  color: #2098f3;
  text-decoration: none;
  word-wrap: break-word;
  cursor: pointer;
}

a:hover {
  color: #40a9ff;
  text-decoration: none;
}

/**
  Button
**/


.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 0 20px;
  font-size: 14px;
  border-radius: 4px;
  height: 45px;
  line-height: 45px;
  -webkit-user-select: none;
  user-select: none;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  position: relative;
  color: rgba(0,0,0,.65);
  background-color: transparent;
  border-color: #e8e8e8;
  outline: none;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-lg {
  padding: 0 30px;
}

.btn-primary {
    color: #fff;
    background-color: #2098f3;
    border-color: #2098f3;  
} 

.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active {
  background-color: #40a9ff;
  border-color: #40a9ff;
}

.btn-success {
    color: #fff;
    background-color: #52c41a;
    border-color: #52c41a;    
}

.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active {
  background-color: #52c41a;
  border-color: #52c41a;
}


.btn-link {
  border: none;
  height: 34px;
  padding: 0 15px;
}

.btn-link:hover {
  background-color: rgba(158,158,158, 0.20);
}


/**
  Form
**/

.form-item {
	margin-bottom: 18px;
}

.form-item .btn {
    cursor: pointer;
}

.form-item label {
    font-size: 0.85em;
    font-weight: 500;
    display: inline-block;
    margin-bottom: 5px;
    color: rgba(0,0,0,.65);
}

.form-control {
  margin: 0;
  padding: 0;
  list-style: none;
  position: relative;
  display: inline-block;
  padding: 4px 11px;
  width: 100%;
  height: 45px;
  font-size: 0.87em;
  line-height: 45px;
  color: rgba(0,0,0,.80);
  background-color: #fff;
  background-image: none;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  transition: all .3s;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
}


.form-control:hover, .form-control:focus, .form-control:active {
  border-color: #40a9ff;
  outline: 0;
  border-right-width: 1px!important;
}

.form-control:focus, .form-control:active {
  box-shadow: 0 0 0 2px rgba(24,144,255,.2);    
}

.form-control.invalid {
  border-color: #f5222d;
}

.form-control.invalid:focus, .form-control.invalid:active {
  box-shadow: 0 0 0 2px rgba(245,34,45,.2);        
} 

.form-control[disabled], fieldset[disabled] .form-control {
  cursor: not-allowed;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #f6f8fa;
  opacity: 1;
}

.form-label {
  margin-bottom: 10px;
}

/**
  Or separator
**/

.or-separator {
  border-bottom: 1px solid #eee;
  padding: 10px 0;
  position: relative;
  display: block;
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: 1em;    
}

.or-text {
  position: absolute;
  left: 46%;
  top: 0;
  background: #fff;
  padding: 10px;
  color: rgba(0,0,0,.45);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EAGU,sBAAsB;AAChC;;AAEA;;EAIU,sBAAsB;AAChC;;AAEA;;EAIU,sBAAsB;EAC9B,UAAU;AACZ;;AAEA;EACE,SAAS;IACP;;gBAEY;IACZ,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;EAEE;;AAEF;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE;;;AAGF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAElB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EAGzB,iBAAiB;EAEjB,kDAAkD;EAClD,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;;AAGA;;EAEE;;AAEF;CACC,mBAAmB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;;AAGA;EACE,qBAAqB;EACrB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;;AAEF;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/*\r\n Copyright 2024 European Commission\r\n\r\n Licensed under the Apache License, Version 2.0 (the \"License\");\r\n you may not use this file except in compliance with the License.\r\n You may obtain a copy of the License at\r\n\r\n      https://www.apache.org/licenses/LICENSE-2.0\r\n\r\n Unless required by applicable law or agreed to in writing, software\r\n distributed under the License is distributed on an \"AS IS\" BASIS,\r\n WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n See the License for the specific language governing permissions and\r\n limitations under the License.\r\n */\r\n\r\n* {\r\n  -webkit-box-sizing: border-box;\r\n     -moz-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n\r\n*:before,\r\n*:after {\r\n  -webkit-box-sizing: border-box;\r\n     -moz-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n\r\ninput[type=\"checkbox\"],\r\ninput[type=\"radio\"] {\r\n  -webkit-box-sizing: border-box;\r\n     -moz-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding: 0;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n      sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  max-width: 1300px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  padding-left: 15px;\r\n  padding-right: 15px; \r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n  .container {\r\n    padding-left: 30px;\r\n    padding-right: 30px;\r\n  }\r\n}\r\n\r\n/**\r\n  Link\r\n**/\r\n\r\na {\r\n  color: #2098f3;\r\n  text-decoration: none;\r\n  word-wrap: break-word;\r\n  cursor: pointer;\r\n}\r\n\r\na:hover {\r\n  color: #40a9ff;\r\n  text-decoration: none;\r\n}\r\n\r\n/**\r\n  Button\r\n**/\r\n\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  -ms-touch-action: manipulation;\r\n  touch-action: manipulation;\r\n  cursor: pointer;\r\n  background-image: none;\r\n  border: 1px solid transparent;\r\n  white-space: nowrap;\r\n  padding: 0 20px;\r\n  font-size: 14px;\r\n  border-radius: 4px;\r\n  height: 45px;\r\n  line-height: 45px;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);\r\n  transition: all .3s cubic-bezier(.645,.045,.355,1);\r\n  position: relative;\r\n  color: rgba(0,0,0,.65);\r\n  background-color: transparent;\r\n  border-color: #e8e8e8;\r\n  outline: none;\r\n}\r\n\r\n.btn-block {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.btn-lg {\r\n  padding: 0 30px;\r\n}\r\n\r\n.btn-primary {\r\n    color: #fff;\r\n    background-color: #2098f3;\r\n    border-color: #2098f3;  \r\n} \r\n\r\n.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active {\r\n  background-color: #40a9ff;\r\n  border-color: #40a9ff;\r\n}\r\n\r\n.btn-success {\r\n    color: #fff;\r\n    background-color: #52c41a;\r\n    border-color: #52c41a;    \r\n}\r\n\r\n.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active {\r\n  background-color: #52c41a;\r\n  border-color: #52c41a;\r\n}\r\n\r\n\r\n.btn-link {\r\n  border: none;\r\n  height: 34px;\r\n  padding: 0 15px;\r\n}\r\n\r\n.btn-link:hover {\r\n  background-color: rgba(158,158,158, 0.20);\r\n}\r\n\r\n\r\n/**\r\n  Form\r\n**/\r\n\r\n.form-item {\r\n\tmargin-bottom: 18px;\r\n}\r\n\r\n.form-item .btn {\r\n    cursor: pointer;\r\n}\r\n\r\n.form-item label {\r\n    font-size: 0.85em;\r\n    font-weight: 500;\r\n    display: inline-block;\r\n    margin-bottom: 5px;\r\n    color: rgba(0,0,0,.65);\r\n}\r\n\r\n.form-control {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  position: relative;\r\n  display: inline-block;\r\n  padding: 4px 11px;\r\n  width: 100%;\r\n  height: 45px;\r\n  font-size: 0.87em;\r\n  line-height: 45px;\r\n  color: rgba(0,0,0,.80);\r\n  background-color: #fff;\r\n  background-image: none;\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 4px;\r\n  transition: all .3s;\r\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\r\n}\r\n\r\n\r\n.form-control:hover, .form-control:focus, .form-control:active {\r\n  border-color: #40a9ff;\r\n  outline: 0;\r\n  border-right-width: 1px!important;\r\n}\r\n\r\n.form-control:focus, .form-control:active {\r\n  box-shadow: 0 0 0 2px rgba(24,144,255,.2);    \r\n}\r\n\r\n.form-control.invalid {\r\n  border-color: #f5222d;\r\n}\r\n\r\n.form-control.invalid:focus, .form-control.invalid:active {\r\n  box-shadow: 0 0 0 2px rgba(245,34,45,.2);        \r\n} \r\n\r\n.form-control[disabled], fieldset[disabled] .form-control {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\r\n  background-color: #f6f8fa;\r\n  opacity: 1;\r\n}\r\n\r\n.form-label {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/**\r\n  Or separator\r\n**/\r\n\r\n.or-separator {\r\n  border-bottom: 1px solid #eee;\r\n  padding: 10px 0;\r\n  position: relative;\r\n  display: block;\r\n  margin-top: 20px;\r\n  margin-bottom: 30px;\r\n  font-size: 1em;    \r\n}\r\n\r\n.or-text {\r\n  position: absolute;\r\n  left: 46%;\r\n  top: 0;\r\n  background: #fff;\r\n  padding: 10px;\r\n  color: rgba(0,0,0,.45);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
